import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={51}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m33.67 7 4.652 33.921.417 3.403a2 2 0 0 1-1.74 2.23L7.717 50.147a2 2 0 0 1-2.229-1.741L.981 11.693a1 1 0 0 1 .881-1.115l2.43-.273m1.963-.22 2.293-.258-2.293.257Z"
      clipRule="evenodd"
    />
    <path
      fill="#0469C5"
      d="M34.29 6.915a.625.625 0 1 0-1.239.17l1.239-.17Zm4.032 34.006.62-.076-.001-.009-.62.085Zm.417 3.403.62-.076-.62.076ZM37 46.554l.075.62-.076-.62ZM7.717 50.147l.076.62-.076-.62Zm-2.229-1.741.62-.076-.62.076Zm-3.627-37.83.07.622-.07-.621Zm2.5.35a.625.625 0 1 0-.14-1.243l.14 1.242Zm1.823-1.464a.625.625 0 1 0 .14 1.242l-.14-1.242Zm2.433.985a.625.625 0 1 0-.14-1.242l.14 1.242ZM33.05 7.085l4.651 33.921 1.239-.17L34.29 6.915l-1.239.17Zm4.65 33.912.418 3.404 1.24-.153-.417-3.403-1.24.152Zm.418 3.404a1.375 1.375 0 0 1-1.197 1.532l.152 1.24a2.625 2.625 0 0 0 2.286-2.925l-1.24.153Zm-1.197 1.532-29.28 3.595.152 1.24 29.28-3.595-.152-1.24Zm-29.28 3.595a1.375 1.375 0 0 1-1.533-1.197l-1.24.152a2.625 2.625 0 0 0 2.925 2.286l-.152-1.241Zm-1.533-1.197L1.602 11.617.36 11.77l4.508 36.714 1.24-.152ZM1.602 11.617a.375.375 0 0 1 .326-.418l-.152-1.24c-.891.109-1.524.92-1.415 1.81l1.24-.152Zm.326-.418h.004l-.14-1.243-.016.002.152 1.241Zm.004 0 2.43-.273-.14-1.242-2.43.272.14 1.243Zm4.392-.494 2.294-.257-.14-1.242-2.293.257.14 1.242Z"
    />
    <path
      fill="#E0EEFE"
      fillRule="evenodd"
      d="m32.404 9.135 4.21 30.742.379 3.084a1.802 1.802 0 0 1-1.557 2.017l-26.221 3.22a1.802 1.802 0 0 1-1.999-1.58L3.141 13.428a1 1 0 0 1 .871-1.114l3.244-.399"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      stroke="#0469C5"
      strokeWidth={1.25}
      d="M10.793 2c0-.76.616-1.375 1.375-1.375h22.778c.365 0 .715.145.972.402l6.722 6.718c.258.258.403.608.403.972V40c0 .76-.616 1.375-1.375 1.375h-29.5c-.76 0-1.375-.616-1.375-1.375V2Z"
    />
    <path
      stroke="#0469C5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M35.168 1.201V7a1.5 1.5 0 0 0 1.5 1.5h3.967M15.832 34.001h13m-13-25.5h13-13Zm0 6h21.5-21.5Zm0 6.5h21.5-21.5Zm0 6.5h21.5-21.5Z"
    />
  </svg>
)
export default SvgComponent
